export default {
  name: "Lock",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M16 16c-2.24 0-4 1.76-4 4a3.93 3.93 0 0 0 3 3.86V25a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-1.14c1.74-.43 3-1.97 3-3.86 0-2.24-1.76-4-4-4zm0 6c-1.14 0-2-.86-2-2s.86-2 2-2c1.14 0 2 .86 2 2s-.86 2-2 2zm9.99-10H23V8.5c0-3-1.83-6.5-7-6.5S9 5.5 9 8.5V12H6.01C4.9 12 4 12.9 4 14.01v13.98C4 29.1 4.9 30 6.01 30h19.98c1.11 0 2.01-.9 2.01-2.01V14.01c0-1.11-.9-2.01-2.01-2.01zM11 8.5c0-1.06.36-4.5 5-4.5s5 3.44 5 4.5V12H11V8.5zM25.99 28 6 27.99 6.01 14h19.98l.01.01L25.99 28z",
  },
}
